import React from 'react';
import Pricing from '../components/Pricing/Pricing';

function PricingPage(props) {
    return (
       <Pricing/>
    );
}

export default PricingPage;